import { render, staticRenderFns } from "./brandDescription.vue?vue&type=template&id=fa9264b8"
import script from "./brandDescription.vue?vue&type=script&lang=ts"
export * from "./brandDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports